import React, {useState, useEffect} from "react";
import Title from "../dashboard/Title";
import Button from "@material-ui/core/Button";
import UserService from "../../services/user.service";
import {logOut} from "../../helpers/logout";
import Paper from "@material-ui/core/Paper";
import {InputAdornment} from "@material-ui/core";
import TextInput from "../form/input/TextInput";
import ActionButton from "../form/input/ActionButton";
import Tooltip from "@material-ui/core/Tooltip";
import PhoneIcon from "@material-ui/icons/Phone";
import {Search} from "@material-ui/icons";
import useTable from "./useTable";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import {useDashboardStyles} from "../settings/dashboardStyles";
import {makeStyles} from "@material-ui/core/styles";

const useLocalStyles = makeStyles((theme) => ({
    loadMoreRow: {
        marginTop: theme.spacing(1.5),
        display: "flex",
        justifyContent: "center",
    },
    wrap: {
        marginTop: theme.spacing(3),
    },
    searchInput: {
        flex: "1 1 320px",
        minWidth: 240,
    },
    actionsCell: {
        whiteSpace: "nowrap",
        width: 1,
    },
    actionsRow: {
        display: "inline-flex",
        flexWrap: "nowrap",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: theme.spacing(0.75),
    },
}));

export default function PublicContactList(props) {
    const classes = useDashboardStyles();
    const localClasses = useLocalStyles();

    const [contacts, setContacts] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [filterFn, setFilterFn] = useState({
        fn: items => items
    });
    const [limit, setLimit] = useState(100);

    const headCells = [
        {id: 'name', label: 'Názov'},
        {id: 'phone', label: 'Telefón'},
        {id: 'email', label: 'Email'},
        {id: 'actions', label: 'Akcie', disableSorting: true, align: 'right'},
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(contacts, headCells, filterFn);

    useEffect(() => {
        const search = searchText.trim().toLowerCase();
        setFilterFn({
            fn: items => {
                if (!search) return items;

                return items.filter(item =>
                    (item.name || '').toLowerCase().includes(search) ||
                    (item.email || '').toLowerCase().includes(search) ||
                    (item.phone || '').toLowerCase().includes(search)
                );
            }
        });
    }, [searchText]);

    const hasPhone = (item) => Boolean((item.phone || '').trim());

    const handleCall = (phone) => () => {
        if (!phone) return;
        window.location.href = `tel:${phone}`;
    };

    useEffect(() => {
        UserService.getPublicContacts(limit).then(
            (response) => {
                setContacts(response.data);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                }
            }
        );
    }, [limit, props]);

    const handleNoLimit = () => {
        setLimit(0);
    }

    return (
        <div className={localClasses.wrap}>
            <Paper className={classes.paper} elevation={0}>
                <div className={classes.sectionHeader}>
                    <Title>Zoznam verejných kontaktov</Title>
                    <div className={classes.sectionToolbar}>
                        <TextInput
                            className={localClasses.searchInput}
                            label="Vyhľadať kontakt"
                            placeholder="Meno, email alebo telefón"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search fontSize="small"/>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </div>
                </div>

                {contacts.length === 0 ? (
                    <div className={classes.emptyState}>
                        Žiadne verejné kontakty zatiaľ neexistujú.
                    </div>
                ) : (
                    <>
                        <TblContainer>
                            <TblHead/>
                            <TableBody>
                                {recordsAfterPagingAndSorting().map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell><strong>{item.name}</strong></TableCell>
                                        <TableCell>{item.phone}</TableCell>
                                        <TableCell>{item.email}</TableCell>
                                        <TableCell align="right" className={localClasses.actionsCell}>
                                            <div className={localClasses.actionsRow}>
                                                <Tooltip title={hasPhone(item) ? "Zavolať" : "Telefónne číslo nie je vyplnené"}>
                                                    <span>
                                                        <ActionButton color="primary" disabled={!hasPhone(item)} onClick={handleCall(item.phone)}>
                                                            <PhoneIcon fontSize="small"/>
                                                        </ActionButton>
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </TblContainer>
                        <TblPagination/>
                        <div className={localClasses.loadMoreRow}>
                            <Button size="small" className={classes.secondaryAction} onClick={handleNoLimit}>
                                Načítať viac ako max. 100 záznamov
                            </Button>
                        </div>
                    </>
                )}
            </Paper>
        </div>
    );
}
